export function cartTotal(cartTotal) {
  return {
    type: 'CART_TOTAL',
    cartTotal
  }
}